import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import type { AuthProvidersResponseDto } from '@lunary/api-client'
import { api } from '../../shared/api/client'
import { runtimeApiBase } from '../../shared/config'
import styles from './oauth-login.module.css'

const ERRORS: Readonly<Record<string, string>> = {
  admin_account_not_found:
    'Этот аккаунт не привязан к сотруднику Lunary. Войдите по email и паролю или привяжите его в профиле приложения.',
  admin_access_denied: 'У этого аккаунта нет доступа к админке.',
  user_blocked: 'Аккаунт заблокирован.',
}

function errorText(code: string): string {
  return ERRORS[code] ?? 'Не удалось войти, попробуйте ещё раз.'
}

const PROVIDERS = [
  { id: 'yandex', label: 'Войти через Яндекс ID' },
  { id: 'google', label: 'Войти через Google' },
] as const

export function OAuthLogin() {
  const [error] = useState(() => new URLSearchParams(window.location.search).get('error'))
  const providers = useQuery({
    queryKey: ['auth-providers'],
    queryFn: () => api.get<AuthProvidersResponseDto>('/auth/providers'),
    retry: false,
    staleTime: 5 * 60_000,
  })
  const data = providers.data
  const available = data?.admin_oauth ? PROVIDERS.filter((p) => data[p.id]) : []

  return (
    <>
      {available.length > 0 && (
        <div className={styles.providers}>
          {available.map((p) => (
            <a key={p.id} className={styles.provider} href={`${runtimeApiBase()}/auth/${p.id}/start?app=admin`}>
              {p.label}
            </a>
          ))}
          <span className={styles.divider}>или по email</span>
        </div>
      )}
      {error && (
        <p className="error-box" role="alert">
          {errorText(error)}
        </p>
      )}
    </>
  )
}
